import ErrorSVG from "../../content/img/error.svg";
import { useTranslation, Trans } from "react-i18next";
import { Button } from "@etframework/ui.components";
import { useNavigate } from "react-router-dom";

export const InternalServerError = () => {
  const { t } = useTranslation(["errorPages"]);
  const navigate = useNavigate();

  return (
    <>
      <div className="error-page-container">
        <img
          src={ErrorSVG}
          alt="Error illustration"
          className="error-image unauthorized"
        />
        <h1 className="error-title">
          {t("ServerError.title")}
        </h1>
        <p className="error-message">
          <Trans i18nKey="errorPages:ServerError.message" />
        </p>
        <div className="mt-4">
          <Button
            onClick={() => navigate("/")}
          >
            {t("HomeBtn")}
          </Button>
        </div>
      </div>
    </>
  );
};
